import React from 'react'
import { FormattedDate } from 'react-intl'
import { FlexWrapper } from 'lib/ui/components'
import { useTrustpilotReviews } from 'hooks/trustpilot'
import { Breadcrumbs } from 'components/Breadcrumbs'
import { RatingStars } from 'components/Reviews/components/RatingStars'
import { TrustpilotWidget } from 'app/sofia/components/TrustpilotReviews'
import { ReviewWrapper, ReviewsList } from 'app/sofia/components/TrustpilotReviews/styled'
import { Wrapper, Heading, Sidebar, Content } from './styled'

export const Reviews = () => {
  const { reviews, setOrderBy, setFilterStars } = useTrustpilotReviews(false)
  const reviewsArray = reviews?.reviews

  const handleSortChange = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    setOrderBy(target.value)
  }

  return (
    <Wrapper>
      <Heading>
        <h1>
          Reviews
        </h1>
        <TrustpilotWidget
          type='button'
        />
      </Heading>
      <Breadcrumbs
        title='Reviews'
      />
      <FlexWrapper className='reviews__content'>
        <Sidebar>
          <h2>Filter</h2>
          <div className='reviews__rating'>
            <h3>Rating</h3>
            {Array.from({ length: 5 }, (_, i) => i + 1).map((el?: number) => {
              const starString = el === 1 ? `${el} star` : `${el} stars`
              return (
                <div key={el} className='reviews__rating-stars' onClick={() => setFilterStars(el)}>
                  <RatingStars
                    ratingCount={el}
                  />
                  <span>{starString}</span>
                </div>
              )
            })}
          </div>
        </Sidebar>
        <Content>
          <h2>Customer Reviews</h2>
          <TrustpilotWidget
            type='trustScore'
          />
          <div className='reviews__toolbar'>
            <label>Sort Reviews By:</label>
            <select
              onChange={handleSortChange}
            >
              {sortList?.map((option: any) => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          <ReviewsList>
            {reviewsArray?.map((review: any, i: number) => {
              const { stars, text, consumer, createdAt } = review

              return (
                <ReviewWrapper
                  key={i}
                >
                  <RatingStars
                    ratingCount={stars}
                  />
                  <h3 className='review__title'>{text}</h3>
                  <div className='review__cotent'>
                    <div>
                      <div>{consumer.displayName}</div>
                      <FormattedDate
                        value={createdAt}
                        day='numeric'
                        month='long'
                        year='numeric'
                      />
                    </div>
                  </div>

                </ReviewWrapper>
              )
            })}
          </ReviewsList>
        </Content>
      </FlexWrapper>
    </Wrapper>
  )
}

const sortList = [
  {
    label: 'Most Recent',
    value: 'createdat.desc'
  },
  {
    label: 'Older',
    value: 'createdat.asc'
  },
  {
    label: 'Best rated',
    value: 'stars.desc'
  },
  {
    label: 'Lowest rated',
    value: 'stars.asc'
  }
]
